import { useCallback } from 'react';
import { useApiCall } from './useApiCall';
import { useValidUserId, useIsCompany } from './useLocalStorage';
import { getCompany, getEmployees } from '../services/userservice';
import { handleApiError } from '../utils/validation';

/**
 * Hook personalizado para cargar el perfil del usuario (empresa o empleado)
 * @returns {Object} - {profile, loading, error, refetch, isCompany}
 */
export const useProfile = () => {
  const { userId, isValid } = useValidUserId();
  const userIsCompany = useIsCompany();

  const fetchProfile = useCallback(async () => {
    if (!isValid || !userId) {
      return null;
    }

    const entityType = userIsCompany ? 'Company' : 'Employee';
    const fetchFunction = userIsCompany ? getCompany : getEmployees;

    try {
      const result = await fetchFunction(userId);
      if (userIsCompany) {
        localStorage.setItem('companyId', result.id);
        localStorage.setItem('active_offers', result.active_offers);
        localStorage.setItem('active_offers_limit', result.active_offers_limit);
        localStorage.setItem('available_credits', result.available_credits);
        localStorage.setItem('verified', result.verified);        
      }
      return result;
    } catch (error) {
      handleApiError(error, entityType);
      throw error;
    }
  }, [userId, isValid, userIsCompany]);

  const { data, loading, error, refetch } = useApiCall(
    fetchProfile,
    [userId, userIsCompany],
    { immediate: isValid && !!userId }
  );

  return {
    profile: data,
    loading,
    error,
    refetch,
    isCompany: userIsCompany
  };
};
